import { combineReducers } from 'redux';
import visitHistory from './visit-history';
import outreachAggregate from './outreach-aggregate';
import outreachAggregateOptions from './outreach-aggregate/options';

export default combineReducers({
  outreachAggregate,
  outreachAggregateOptions,
  visitHistory
});
